/**
 * Initializes one Carraro footer accordion group.
 * @param {HTMLElement} footer
 */
function initializeFooterAccordions(footer) {
  if (footer.dataset.accordionsInitialized === 'true') return;
  footer.dataset.accordionsInitialized = 'true';

  const items = Array.from(footer.querySelectorAll('[data-footer-accordion]'));

  const closeItem = (item) => {
    const trigger = item.querySelector('[data-footer-accordion-trigger]');
    const panel = item.querySelector('[data-footer-accordion-panel]');
    if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    if (trigger.getAttribute('aria-expanded') !== 'true') {
      panel.style.maxHeight = '0px';
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.maxHeight = `${panel.scrollHeight}px`;

    requestAnimationFrame(() => {
      panel.style.maxHeight = '0px';
      panel.classList.remove('is-open');
    });
  };

  const openItem = (item) => {
    const trigger = item.querySelector('[data-footer-accordion-trigger]');
    const panel = item.querySelector('[data-footer-accordion-panel]');
    if (!(trigger instanceof HTMLButtonElement) || !(panel instanceof HTMLElement)) return;

    items.forEach((otherItem) => {
      if (otherItem !== item) closeItem(otherItem);
    });

    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-open');
    panel.style.maxHeight = `${panel.scrollHeight}px`;
  };

  items.forEach((item) => {
    const trigger = item.querySelector('[data-footer-accordion-trigger]');
    if (!(trigger instanceof HTMLButtonElement)) return;

    trigger.addEventListener('click', () => {
      if (trigger.getAttribute('aria-expanded') === 'true') closeItem(item);
      else openItem(item);
    });
  });

  window.addEventListener('resize', () => {
    const openPanel = footer.querySelector('[data-footer-accordion-panel].is-open');
    if (openPanel instanceof HTMLElement) openPanel.style.maxHeight = `${openPanel.scrollHeight}px`;
  });
}

function initializeFooters(scope = document) {
  scope.querySelectorAll('[data-footer-carraro]').forEach((footer) => {
    if (footer instanceof HTMLElement) initializeFooterAccordions(footer);
  });
}

initializeFooters();

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof Element) initializeFooters(event.target);
});
